import { Dialog, DialogActions, DialogContent } from '@mui/material';
import MuiDialogTitleClose from 'components/MuiExtras/MuiDialogTitleClose';
import { TopicShortViewModel } from 'models/ApiModels';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import TopicAdminDashboard from 'views/Topic/Dashboard/TopicAdminDashboard';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    topic: TopicShortViewModel;
    onClose: () => void;
}

type Props = IProps;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

const TopicDashboardDialog: React.FC<Props> = (props) => {
    const { t } = useTranslation();
    const { topic, onClose } = props;

    return (
        <Dialog
            open
            fullWidth
            onClose={() => { onClose(); }}
            maxWidth="lg"
        >
            <MuiDialogTitleClose
                title={t("Views.Topic.Dialogs.TopicDashboardDialog.BoxTitle")}
                subtitle={topic.name}
                onClose={() => { onClose(); }}
            />

            <DialogContent>
                <TopicAdminDashboard topic={props.topic} />
            </DialogContent>

            <DialogActions>
            </DialogActions>
        </Dialog>
    );

};

export default TopicDashboardDialog;